import Vue from 'vue';
import {getField, updateField} from 'vuex-map-fields';

export default {
  namespaced: true,

  state: {
    general: {
      gender: null,
      height: {
        metric: null,
        imperial: {
          feet: null,
          inch: null,
        },
      },
      weight: '',
      age: '',
      fitPreference: null, // -2 -1 0 1 2; 0 = normal
      unitSystem: 'metric', // or imperial
    },

    female: {
      tummyShape: 0,  // -1,0,1; 0 = average
      hipShape: 0,    // -1,0,1; 0 = average
      bra: {
        sizeRegion: 'american',
        bust: null,
        cup: null,
      },
    },

    male: {
      chestShape: 0,  // -1,0,1; 0 = average
      tummyShape: 0,  // -1,0,1; 0 = average
    },

    fitPreferences: [], // waist(men) & rise(women)

    brands: [],
  },

  getters: {
    getField,

    getUnitSystem: (state) => {
      return state.general.unitSystem;
    },

    getGenderHumanReadable: (state) => {
      if (state.general.gender) {
        return state.general.gender === 'M' ? 'male' : 'female';
      }
      return 'male';
    },

    getCalculatedHeight: (state) => {
      if (state.general.unitSystem === 'imperial') {
        // calculate feet to inches
        const feet = state.general.height.imperial.feet ? parseInt(state.general.height.imperial.feet) : 0;
        const inch = state.general.height.imperial.inch ? parseInt(state.general.height.imperial.inch) : 0;

        return feet * 12 + inch;
      }

      return parseInt(state.general.height.metric);
    },

    getGender: (state) => {
      return state.general.gender;
    },

    getAllSelections: (state, getters) => {
      const gender = getters['getGenderHumanReadable'];

      const general = {...state.general};
      general.height = getters['getCalculatedHeight'];

      return {
        general,
        [gender]: state[gender],
        fitPreferences: state.fitPreferences,
        brands: state.brands,
      };
    },

    getFitPreference: (state) => (type) => {
      const preference = state.fitPreferences.find(preference => preference.type === type);

      if (preference) {
        return preference.value;
      }
      return null;
    },
  },

  mutations: {
    updateField,

    setUnitSystem: (state, payload) => {
      state.general.unitSystem = payload;
    },

    setTummyShape: (state, payload) => {
      state[payload.gender].tummyShape = payload.value;
    },

    addBrand: (state, payload) => {
      const index = state.brands.findIndex(item => item.id === payload.id && item.size === payload.size);

      if (index === -1) {
        state.brands.push({
          id: payload.id,
          name: payload.name,
          size: payload.size,
        });
      }
    },

    setFitPreference: (state, payload) => {
      const index = state.fitPreferences.findIndex(preference => preference.type === payload.type);

      if (index === -1) {
        state.fitPreferences.push(payload);
      } else {
        Vue.set(state.fitPreferences, index, payload);
      }
    },

    clearFitPreferences: (state) => {
      state.fitPreferences = [];
    },

    removeBrand: (state, payload) => {
      state.brands.splice(payload.index, 1);
    },

    // needed for VuexReset plugin
    reset: () => {
    },
  },
};
